'use client'

import { createContext, useContext, useState } from 'react'
import type { User, Role, Subscription, OnboardingAnswer } from '@/lib/types'

type UserContextType = {
  user: User | null
  setUser: (user: User | null) => void
}

const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {},
})

type UserProviderProps = {
  children: React.ReactNode
  initialData?: User | null
}

export function UserProvider({ children, initialData }: UserProviderProps) {
  const [user, setUser] = useState<User | null>(initialData || null)

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export function useUser() {
  const context = useContext(UserContext)
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider')
  }
  return context
}
